import { render, staticRenderFns } from "./AddOrEditItemDialog.vue?vue&type=template&id=7154f138&"
import script from "./AddOrEditItemDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrEditItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditItemDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports